import { render, staticRenderFns } from "./DesktopPage.vue?vue&type=template&id=12c51fb6&scoped=true&"
import script from "./DesktopPage.vue?vue&type=script&lang=js&"
export * from "./DesktopPage.vue?vue&type=script&lang=js&"
import style0 from "./DesktopPage.vue?vue&type=style&index=0&id=12c51fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c51fb6",
  null
  
)

export default component.exports